import frontSightSDK from '@pzds/frontend-tracking'
import request, { fetchAlive } from '@/utils/axios'
// import frontSightSDK from '../utils/track'
import { refreshUUIDClient, checkUUIDClient, refreshTrackTime } from '@/utils/getTrackId'
const env = require('../env')
const packageJson = require('../package.json')

// 埋点类
export default ({ app }, inject) => {
    const router = app.router
    const url = `${env[packageJson.env].ENV_TRACK_API}/dashboard/monitor/public/common/count/hit`
    const trackRecord = data => {
        refreshTrackTime(app)
        return request({
            url,
            method: 'post',
            data
        })
    }

    const trackRecordAlive = data => {
        refreshTrackTime(app)
        fetchAlive(url, data)
    }

    const autoTracking = frontSightSDK.useWebAutoTracking(router, trackRecord, trackRecordAlive)

    function refreshUUID() {
        const globalId = refreshUUIDClient(app)
        autoTracking.config('params', { globalId })
    }
    // 在应用启动时初始化埋点系统
    try {
        let globalId = checkUUIDClient(app)
        router.beforeEach((to, from, next) => {
            if (to.name === 'goodsDetails' || to.name === 'generalGoodsDetails' || to.path.includes('confirmOrder')) {
                globalId = app.$cookies.get('new_track_uuid') || globalId
            }
            autoTracking.config('params', { globalId })
            next()
        })
        autoTracking.config('params', { globalId })
        autoTracking.config('pageUnload', () => {
            // 刷新cookie
            refreshUUID()
        })
        autoTracking.initRouteTracking()

    } catch (error) {
        console.error('AutoTrackingRouter init failed:', error)
    }
    window.onNuxtReady(() => {
        try {
            autoTracking.init()
        }
        catch (e) {
            console.error('AutoTracking init failed:', e)
        }
    })

    // 注入方法 埋点事件
    inject('trackEvent', eventData => {
        if (autoTracking) {
            autoTracking.addEvent(eventData)
        }
    })
    //  更新globalId
    inject('updateTrackUUID', () => {
        refreshUUID()
    })
}
